import { css } from 'styled-components';
import token from 'styled-token';
import { StyledCheckbox } from '../../components/Checkbox/Checkbox.styles';
import { StyledLabel } from '../../components/Label/Label.styles';
import { StyledRadio } from '../../components/Radio/Radio.styles';
import { StyledSwitchWrapper } from '../../components/SwitchWrapper/SwitchWrapper.styles';
import { LABELED_CONTROL_POSITIONS } from '../../constants';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var fluidCSS = function fluidCSS(_ref) {
  var fluid = _ref.fluid;
  if (fluid) {
    return "justify-content: space-between;";
  }
  return '';
};
var positionCSS = function positionCSS(props) {
  if (props.labelPosition === LABELED_CONTROL_POSITIONS.left) {
    return token('LabeledControl.Label.paddingRight', function (paddingRight) {
      return css(["> ", "{order:-1;padding-right:", ";}"], StyledLabel, paddingRight ? paddingRight + "px" : spaceMixin('xs')(props));
    })(props);
  }
  return token('LabeledControl.Label.paddingLeft', function (paddingLeft) {
    return css(["> ", "{padding-left:", ";}"], StyledLabel, paddingLeft ? paddingLeft + "px" : spaceMixin('xs')(props));
  })(props);
};

// Calculates the offset of components based on the desired height.
// The desired height is the height when the label spans only one line;
// when the label spans multiple lines, we need to make sure we maintain the correct padding.
var offsetCSS = function offsetCSS(_ref2) {
  var size = _ref2.size;
  return token({
    desiredHeight: 'LabeledControl.desiredHeight',
    switchHeight: "Switch.sizes." + size + ".height",
    radioHeight: 'Radio.size',
    lineHeights: 'lineHeights',
    fontType: 'LabeledControl.fontType'
  }, function (_ref3) {
    var desiredHeight = _ref3.desiredHeight,
      switchHeight = _ref3.switchHeight,
      radioHeight = _ref3.radioHeight,
      lineHeights = _ref3.lineHeights,
      fontType = _ref3.fontType;
    var labelHeight = lineHeights && lineHeights[fontType];
    var radioOffset = (desiredHeight - radioHeight) / 2;
    var labelOffset = (desiredHeight - labelHeight) / 2;
    var switchOffset = (desiredHeight - switchHeight) / 2;
    return css(["> ", ",> ", "{margin-top:", "px;}> ", "{margin-top:", "px;}> ", "{padding-top:", "px;padding-bottom:", "px;}"], StyledCheckbox, StyledRadio, radioOffset, StyledSwitchWrapper, switchOffset, StyledLabel, labelOffset, labelOffset);
  });
};

/** @class LabeledControlMixin */
/** @method */
export var LabeledControlMixin = function LabeledControlMixin(props) {
  return token('LabeledControl.fontType', function (fontType) {
    return css(["display:flex;> ", ":after{content:none;}> ", ",> ", ",> ", "{flex-shrink:0;}> ", ",> ", ",> ", "{~ ", "{", "}}", " ", " ", " ", ""], StyledLabel, StyledCheckbox, StyledRadio, StyledSwitchWrapper, StyledCheckbox, StyledRadio, StyledSwitchWrapper, StyledLabel, typographyMixin(Object.assign({
      fontType: fontType
    }, props)), offsetCSS(props), fluidCSS(props), positionCSS(props), spacingMixin(props));
  })(props);
};